import api from "@modules/api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import purchaseQueryKeys from "../purchaseQueryKeys";

type RequestBody = {
  dealId: string;
  locale?: string;
};

const performPost = ({ dealId, locale }: RequestBody) => {
  return api.rawPut(`api/purchases/${dealId}/drop-off-appointment/cancel`, {
    headers: { "Accept-Language": locale ?? "en" },
  });
};

export default function useCancelDropOffAppointmentMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: performPost,
    onSuccess: (_, { dealId }) => {
      queryClient.invalidateQueries({
        queryKey: purchaseQueryKeys.purchases([dealId]),
      });
      queryClient.invalidateQueries({
        queryKey: purchaseQueryKeys.dealTodos(dealId),
      });
    },
  });
}
